(function () {
  var closeIcon = '<img class="close__icon" src="https://cdn.shopify.com/s/files/1/0900/2077/4217/files/svgviewer-png-output.png?v=1785756070">';
  var caret = '<svg class="mfb__caret" viewBox="0 0 10 6" width="12"><path fill="currentColor" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"/></svg>';

  var COLOR_MAP = [
    ['multicolor', 'linear-gradient(135deg,#e74c3c,#f1c40f,#2ecc71,#3498db,#9b59b6)'],
    ['multi', 'linear-gradient(135deg,#e74c3c,#f1c40f,#2ecc71,#3498db,#9b59b6)'],
    ['hellblau', '#a8c8e8'], ['dunkelblau', '#1a2f52'], ['navy', '#1a2f52'], ['blau', '#3468b0'], ['blue', '#3468b0'],
    ['hellgrau', '#c8c8c8'], ['dunkelgrau', '#555555'], ['anthrazit', '#3a3a3a'], ['grau', '#8a8a8a'], ['grey', '#8a8a8a'], ['gray', '#8a8a8a'],
    ['schwarz', '#111111'], ['black', '#111111'],
    ['weiss', '#ffffff'], ['weiß', '#ffffff'], ['white', '#ffffff'], ['offwhite', '#f4f1ea'], ['ecru', '#f0e9dc'], ['creme', '#f2ead9'], ['cream', '#f2ead9'],
    ['beige', '#d9c7a8'], ['sand', '#d8c49a'], ['camel', '#c19a6b'], ['taupe', '#b3a394'],
    ['dunkelgruen', '#2d4a2d'], ['dunkelgrün', '#2d4a2d'], ['olive', '#6b7a42'], ['khaki', '#8a815c'], ['gruen', '#5a8a4a'], ['grün', '#5a8a4a'], ['green', '#5a8a4a'], ['mint', '#a8d8c0'],
    ['bordeaux', '#6d1a2a'], ['weinrot', '#722f37'], ['rot', '#c0392b'], ['red', '#c0392b'],
    ['rosa', '#f0b8c8'], ['pink', '#e0559a'], ['fuchsia', '#d02090'],
    ['orange', '#e8862a'], ['apricot', '#f0c090'], ['coral', '#f08060'],
    ['gelb', '#f0c830'], ['yellow', '#f0c830'], ['senf', '#d0a020'],
    ['lila', '#8a5aa8'], ['violett', '#7a4a9a'], ['purple', '#7a4a9a'], ['flieder', '#c0a8d8'],
    ['braun', '#7a5230'], ['brown', '#7a5230'], ['cognac', '#9a5a2a'], ['schoko', '#4a3020'],
    ['tuerkis', '#30b0a8'], ['türkis', '#30b0a8'], ['petrol', '#2a6a72'],
    ['silber', '#c0c0c8'], ['gold', '#c8a848'],
    ['denim', '#4a6a92'], ['indigo', '#2a3a6a'], ['jeans', '#4a6a92']
  ];
  function colorHex(txt) {
    var t = String(txt).toLowerCase();
    for (var i = 0; i < COLOR_MAP.length; i++) {
      if (t.indexOf(COLOR_MAP[i][0]) !== -1) return COLOR_MAP[i][1];
    }
    return '#d0cdc8';
  }

  function initMacToolbar() {
    var facetsContainer = document.querySelector('.facets-container');
    var grid = document.getElementById('product-grid');
    if (!facetsContainer || !grid) return;
    if (facetsContainer.parentElement.querySelector('.mac-toolbar')) return;

    var srcForm = document.getElementById('FacetFiltersForm');
    var productCount = srcForm ? srcForm.querySelector('.product-count') : document.querySelector('.product-count');
    var titleEl = document.querySelector('.collection-hero__title');
    var titleText = titleEl ? titleEl.textContent.trim().replace('Kategorie: ', '') : 'Kollektion';
    var countText = productCount ? productCount.textContent.trim() : '';

    var saved = 'medium';
    try { saved = localStorage.getItem('macLayout') || 'medium'; } catch (e) {}
    if (saved === 'compact' && window.innerWidth < 990) saved = 'medium';
    grid.setAttribute('data-mac-layout', saved);

    var dL = '<svg class="ic-d" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M0 0h8v8H0zM0 10h8v8H0zM10 0h8v8h-8zM10 10h8v8h-8z"/></svg>';
    var dM = '<svg class="ic-d" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M0 0h4v4H0zM0 7h4v4H0zM0 14h4v4H0zM7 0h4v4H7zM7 7h4v4H7zM7 14h4v4H7zM14 0h4v4h-4zM14 7h4v4h-4zM14 14h4v4h-4z"/></svg>';
    var dC = '<svg class="ic-d" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M0 0h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0z"/></svg>';
    var mL = '<svg class="ic-m" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M0 0h18v18H0z"/></svg>';
    var mM = '<svg class="ic-m" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M0 0h8v8H0zM0 10h8v8H0zM10 0h8v8h-8zM10 10h8v8h-8z"/></svg>';
    var chev = '<svg width="10" viewBox="0 0 10 10" fill="none"><path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"/></svg>';

    var bar = document.createElement('div');
    bar.className = 'mac-toolbar';
    bar.innerHTML =
      '<h1 class="mac-toolbar__title">' + titleText + '</h1>' +
      '<div class="mac-toolbar__count">' + countText + '</div>' +
      '<div class="mac-toolbar__right">' +
        '<div class="mac-switch">' +
          '<button type="button" data-l="large" aria-label="Weniger Spalten">' + dL + mL + '</button>' +
          '<button type="button" data-l="medium" aria-label="Mehr Spalten">' + dM + mM + '</button>' +
          '<button type="button" data-l="compact" aria-label="Kompakt">' + dC + '</button>' +
        '</div>' +
        '<button type="button" class="mac-ctrl mac-ctrl--sort">Sortieren ' + chev + '</button>' +
        '<button type="button" class="mac-ctrl mac-ctrl--filter">Filtern</button>' +
      '</div>';
    facetsContainer.parentElement.insertBefore(bar, facetsContainer);

    var mTitle = document.createElement('h1');
    mTitle.className = 'mac-mobile-title';
    mTitle.textContent = titleText;
    bar.parentElement.insertBefore(mTitle, bar);

    var btns = bar.querySelectorAll('.mac-switch button');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-l') === saved) btns[i].classList.add('is-active');
      btns[i].addEventListener('click', function () {
        for (var j = 0; j < btns.length; j++) btns[j].classList.remove('is-active');
        this.classList.add('is-active');
        var v = this.getAttribute('data-l');
        grid.setAttribute('data-mac-layout', v);
        try { localStorage.setItem('macLayout', v); } catch (e) {}
      });
    }
    function syncActiveForViewport() {
      if (window.innerWidth < 990 && grid.getAttribute('data-mac-layout') === 'compact') {
        grid.setAttribute('data-mac-layout', 'medium');
        for (var k = 0; k < btns.length; k++) btns[k].classList.toggle('is-active', btns[k].getAttribute('data-l') === 'medium');
      }
    }
    window.addEventListener('resize', syncActiveForViewport);
    syncActiveForViewport();

    // ===== SORTIEREN =====
    var sel = document.getElementById('SortBy');
    if (sel) {
      var currentSort = new URL(location.href).searchParams.get('sort_by');
      if (!currentSort) { for (var s = 0; s < sel.options.length; s++) { if (sel.options[s].selected) currentSort = sel.options[s].value; } }
      var sortOverlay = document.createElement('div');
      sortOverlay.id = 'mac-sort-overlay';
      var sortPanel = document.createElement('div');
      sortPanel.id = 'mac-sort-panel';
      var html = '<div class="mac-sheet-head"><span>Sortieren</span><button type="button" class="mac-sheet-close" aria-label="Schliessen">' + closeIcon + '</button></div><div class="mac-sort-list">';
      for (var m = 0; m < sel.options.length; m++) {
        var o = sel.options[m];
        html += '<button type="button" class="mac-sort-opt' + (o.value === currentSort ? ' is-current' : '') + '" data-v="' + o.value + '">' + o.textContent.trim() + '</button>';
      }
      html += '</div>';
      sortPanel.innerHTML = html;
      document.body.appendChild(sortOverlay);
      document.body.appendChild(sortPanel);
      sortPanel.querySelectorAll('.mac-sort-opt').forEach(function (b) {
        b.addEventListener('click', function () {
          var u = new URL(location.href);
          u.searchParams.set('sort_by', this.getAttribute('data-v'));
          u.searchParams.delete('page');
          location.href = u.toString();
        });
      });
      function openSort() { sortOverlay.classList.add('is-open'); sortPanel.classList.add('is-open'); }
      function closeSort() { sortOverlay.classList.remove('is-open'); sortPanel.classList.remove('is-open'); }
      bar.querySelector('.mac-ctrl--sort').addEventListener('click', function (e) { e.stopPropagation(); openSort(); });
      sortOverlay.addEventListener('click', closeSort);
      sortPanel.querySelector('.mac-sheet-close').addEventListener('click', closeSort);
    }

    // ===== FILTER: DATEN AUS DAWN LESEN =====
    function textOf(label) {
      var t = '';
      label.childNodes.forEach(function (n) {
        if (n.nodeType === 3) t += n.textContent;
        else if (n.nodeType === 1 && !n.classList.contains('visually-hidden') && n.tagName !== 'SVG' && n.tagName !== 'svg' && n.tagName !== 'INPUT') t += n.textContent;
      });
      return t.replace(/\(\d+\)/g, '').replace(/\s+/g, ' ').trim();
    }
    function countOf(label) {
      var m = label.textContent.match(/\((\d+)\)/);
      if (m) return parseInt(m[1], 10);
      var li = label.closest('li');
      var vh = li ? li.querySelector('.visually-hidden') : null;
      m = vh ? vh.textContent.match(/\((\d+)/) : null;
      return m ? parseInt(m[1], 10) : null;
    }

    var facetData = { farbe: [], fit: [], sizeLetters: [], sizeNumbers: [], laenge: [], price: null, availability: null, other: [] };
    var srcRoot = srcForm || document;

    srcRoot.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function (inp) {
      var name = inp.name;
      if (name.indexOf('geschlecht') !== -1) return;
      if (name.toLowerCase().indexOf('availability') !== -1) {
        if (inp.value === '1') facetData.availability = { name: name, checked: inp.checked };
        return;
      }
      var label = inp.closest('label') || inp.parentElement;
      var opt = { name: name, value: inp.value, checked: inp.checked, disabled: inp.disabled, count: label ? countOf(label) : null, text: label ? textOf(label) : inp.value };
      if (!opt.text) opt.text = inp.value;

      if (name === 'filter.v.option.size') {
        if (/^(XS|S|M|L|XL|XXL|XXXL|2XL|3XL)$/i.test(inp.value)) facetData.sizeLetters.push(opt);
        else facetData.sizeNumbers.push(opt);
      } else if (name === 'filter.v.option.second size') {
        facetData.laenge.push(opt);
      } else {
        var block = inp.closest('details');
        var lbl = block ? (block.querySelector('.facets__summary-label') || block.querySelector('summary')) : null;
        var blockName = lbl ? lbl.textContent.toLowerCase() : name.toLowerCase();
        if (blockName.indexOf('farbe') !== -1 || blockName.indexOf('color') !== -1 || name.toLowerCase().indexOf('colo') !== -1 || name.toLowerCase().indexOf('farbe') !== -1) facetData.farbe.push(opt);
        else if (blockName.indexOf('fit') !== -1 || name.toLowerCase().indexOf('fit') !== -1) facetData.fit.push(opt);
        else facetData.other.push({ opt: opt, blockLabel: lbl ? lbl.textContent.replace(/\(\d+\)/g, '').trim() : 'Filter' });
      }
    });

    var gteSrc = srcRoot.querySelector('input[name="filter.v.price.gte"]');
    var lteSrc = srcRoot.querySelector('input[name="filter.v.price.lte"]');
    if (gteSrc && lteSrc) {
      var rawMax = lteSrc.getAttribute('max') || lteSrc.getAttribute('data-max') || lteSrc.getAttribute('placeholder') || gteSrc.getAttribute('data-max') || '';
      var maxP = Math.ceil(parseFloat(String(rawMax).replace(/[^\d.,]/g, '').replace(',', '.')));
      if (!maxP || isNaN(maxP) || maxP < 1) maxP = 300;
      facetData.price = { max: maxP };
    }

    facetData.sizeNumbers.sort(function (a, b) { return parseFloat(a.value) - parseFloat(b.value); });
    facetData.laenge.sort(function (a, b) { return parseFloat(a.value) - parseFloat(b.value); });
    var sOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL'];
    facetData.sizeLetters.sort(function (a, b) { return sOrder.indexOf(a.value.toUpperCase()) - sOrder.indexOf(b.value.toUpperCase()); });

    function maxCount(arr) { var mx = 0; arr.forEach(function (o) { if (o.count) mx = Math.max(mx, o.count); }); return mx; }
    var letterMax = maxCount(facetData.sizeLetters);
    var numberMax = maxCount(facetData.sizeNumbers);
    var showLetters = facetData.sizeLetters.length > 0;
    var showNumbers = facetData.sizeNumbers.length > 0;
    if (showLetters && showNumbers) {
      if (numberMax > letterMax * 3) showLetters = false;
      else if (letterMax > numberMax * 3) showNumbers = false;
    }

    // ===== FILTER: EIGENES PANEL BAUEN =====
    var urlNow = new URL(location.href);

    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

    function blockHead(key, label) {
      return '<button type="button" class="mfb__head" data-block="' + key + '"><span>' + label + '</span>' + caret + '</button>';
    }
    function listBlock(key, label, opts) {
      if (!opts.length) return '';
      var h = '<div class="mfb" data-key="' + key + '">' + blockHead(key, label) + '<div class="mfb__body"><div class="mfb__list">';
      opts.forEach(function (o) {
        h += '<label class="mfb__opt' + (o.disabled ? ' is-disabled' : '') + '"><input type="checkbox" data-name="' + esc(o.name) + '" data-value="' + esc(o.value) + '"' + (o.checked ? ' checked' : '') + (o.disabled ? ' disabled' : '') + '><span>' + esc(o.text) + '</span></label>';
      });
      return h + '</div></div></div>';
    }
    function swatchBlock(key, label, opts) {
      if (!opts.length) return '';
      var h = '<div class="mfb" data-key="' + key + '">' + blockHead(key, label) + '<div class="mfb__body"><div class="mfb__swatches">';
      opts.forEach(function (o) {
        var bg = colorHex(o.value);
        var style = bg.indexOf('gradient') !== -1 ? 'background-image:' + bg : 'background-color:' + bg;
        h += '<label class="mfb__swatch' + (o.disabled ? ' is-disabled' : '') + '" title="' + esc(o.text) + '"><input type="checkbox" data-name="' + esc(o.name) + '" data-value="' + esc(o.value) + '"' + (o.checked ? ' checked' : '') + (o.disabled ? ' disabled' : '') + '><span class="mfb__swatch-color" style="' + style + '"></span></label>';
      });
      return h + '</div></div></div>';
    }
    function gridBlock(key, label, opts) {
      if (!opts.length) return '';
      var h = '<div class="mfb" data-key="' + key + '">' + blockHead(key, label) + '<div class="mfb__body"><div class="mfb__grid">';
      opts.forEach(function (o) {
        h += '<label class="mfb__box' + (o.disabled ? ' is-disabled' : '') + '"><input type="checkbox" data-name="' + esc(o.name) + '" data-value="' + esc(o.value) + '"' + (o.checked ? ' checked' : '') + (o.disabled ? ' disabled' : '') + '><span>' + esc(o.text) + '</span></label>';
      });
      return h + '</div></div></div>';
    }
    function priceBlock() {
      if (!facetData.price) return '';
      return '<div class="mfb" data-key="preis">' + blockHead('preis', 'Preis') +
        '<div class="mfb__body"><div class="mfb__price">' +
          '<div class="mac-slider-track"><div class="mac-slider-range"></div>' +
            '<input type="range" class="mac-slider-min" min="0" max="' + facetData.price.max + '" value="0" step="1">' +
            '<input type="range" class="mac-slider-max" min="0" max="' + facetData.price.max + '" value="' + facetData.price.max + '" step="1">' +
          '</div>' +
          '<div class="mfb__price-fields">' +
            '<span class="mfb__price-field"><span>€</span><input type="number" id="mac-price-lo" min="0" max="' + facetData.price.max + '" value="0" inputmode="numeric"></span>' +
            '<span class="mfb__price-bis">bis</span>' +
            '<span class="mfb__price-field"><span>€</span><input type="number" id="mac-price-hi" min="0" max="' + facetData.price.max + '" value="' + facetData.price.max + '" inputmode="numeric"></span>' +
          '</div>' +
        '</div></div></div>';
    }
    function availBlock() {
      if (!facetData.availability) return '';
      return '<div class="mfb" data-key="verfuegbarkeit">' + blockHead('verfuegbarkeit', 'Verfügbarkeit') +
        '<div class="mfb__body"><label class="mfb__toggle">' +
          '<input type="checkbox" data-name="' + esc(facetData.availability.name) + '" data-value="1"' + (facetData.availability.checked ? ' checked' : '') + '>' +
          '<span class="mfb__switch"></span>' +
          '<span class="mfb__toggle-label">Nur lagernde Artikel</span>' +
        '</label></div></div>';
    }

    var panelHtml = '';
    panelHtml += swatchBlock('farbe', 'Farbe', facetData.farbe);
    if (showLetters) panelHtml += gridBlock('groesse', 'Größe', facetData.sizeLetters);
    if (showNumbers) panelHtml += gridBlock('weite', 'Weite', facetData.sizeNumbers);
    if (showNumbers) panelHtml += gridBlock('laenge', 'Länge', facetData.laenge);
    panelHtml += listBlock('fit', 'Fit', facetData.fit);
    panelHtml += priceBlock();
    panelHtml += availBlock();

    var filterBtn = bar.querySelector('.mac-ctrl--filter');
    var filterOverlay = document.createElement('div');
    filterOverlay.id = 'mac-filter-overlay';
    var filterPanel = document.createElement('div');
    filterPanel.id = 'mac-filter-panel';
    filterPanel.innerHTML =
      '<div class="mac-sheet-head"><span>Filter</span><button type="button" id="mac-filter-close" aria-label="Schliessen">' + closeIcon + '</button></div>' +
      '<div id="mac-filter-body">' + panelHtml + '</div>' +
      '<button type="button" id="mac-filter-apply">Anwenden</button>';
    document.body.appendChild(filterOverlay);
    document.body.appendChild(filterPanel);

    var panelBody = filterPanel.querySelector('#mac-filter-body');
    var applyBtn = filterPanel.querySelector('#mac-filter-apply');

    panelBody.querySelectorAll('.mfb__head').forEach(function (h) {
      h.addEventListener('click', function () {
        this.parentElement.classList.toggle('is-open');
      });
    });

    // ===== PREIS-SLIDER =====
    var pr = null;
    if (facetData.price) {
      pr = {
        min: panelBody.querySelector('.mac-slider-min'),
        max: panelBody.querySelector('.mac-slider-max'),
        range: panelBody.querySelector('.mac-slider-range'),
        lo: panelBody.querySelector('#mac-price-lo'),
        hi: panelBody.querySelector('#mac-price-hi'),
        cap: facetData.price.max
      };
      var uG = parseFloat(urlNow.searchParams.get('filter.v.price.gte'));
      var uL = parseFloat(urlNow.searchParams.get('filter.v.price.lte'));
      if (!isNaN(uG)) pr.min.value = Math.min(uG, pr.cap);
      if (!isNaN(uL)) pr.max.value = Math.min(uL, pr.cap);

      var paint = function () {
        var a = parseInt(pr.min.value, 10), b = parseInt(pr.max.value, 10);
        if (a > b) {
          if (document.activeElement === pr.min) { pr.max.value = a; b = a; }
          else { pr.min.value = b; a = b; }
        }
        pr.range.style.left = (a / pr.cap * 100) + '%';
        pr.range.style.right = (100 - b / pr.cap * 100) + '%';
        pr.lo.value = a;
        pr.hi.value = b;
      };
      var fromFields = function () {
        var a = parseInt(pr.lo.value, 10), b = parseInt(pr.hi.value, 10);
        if (isNaN(a)) a = 0;
        if (isNaN(b)) b = pr.cap;
        a = Math.max(0, Math.min(a, pr.cap));
        b = Math.max(0, Math.min(b, pr.cap));
        if (a > b) { var t = a; a = b; b = t; }
        pr.min.value = a;
        pr.max.value = b;
        pr.range.style.left = (a / pr.cap * 100) + '%';
        pr.range.style.right = (100 - b / pr.cap * 100) + '%';
        scheduleCount();
      };
      pr.min.addEventListener('input', function () { paint(); scheduleCount(); });
      pr.max.addEventListener('input', function () { paint(); scheduleCount(); });
      pr.lo.addEventListener('change', fromFields);
      pr.hi.addEventListener('change', fromFields);
      pr.lo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); fromFields(); } });
      pr.hi.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); fromFields(); } });
      paint();
    }

    // ===== URL BAUEN + ANWENDEN =====
    function buildFilterUrl() {
      var u = new URL(location.href);
      Array.from(u.searchParams.keys()).forEach(function (k) {
        if (k.indexOf('filter.') === 0) u.searchParams.delete(k);
      });
      u.searchParams.delete('page');
      panelBody.querySelectorAll('.mfb input[type="checkbox"]:checked').forEach(function (inp) {
        u.searchParams.append(inp.getAttribute('data-name'), inp.getAttribute('data-value'));
      });
      if (pr) {
        var a = parseInt(pr.min.value, 10), b = parseInt(pr.max.value, 10);
        if (a > 0) u.searchParams.append('filter.v.price.gte', a);
        if (b < pr.cap) u.searchParams.append('filter.v.price.lte', b);
      }
      return u;
    }
    applyBtn.addEventListener('click', function () { location.href = buildFilterUrl().toString(); });

    // ===== LIVE-ZÄHLER =====
    var countTimer = null, countCtrl = null;
    function scheduleCount() { clearTimeout(countTimer); countTimer = setTimeout(runCount, 350); }
    function runCount() {
      if (!window.fetch || !window.AbortController) return;
      if (countCtrl) countCtrl.abort();
      countCtrl = new AbortController();
      applyBtn.classList.add('is-loading');
      fetch(buildFilterUrl().toString(), { signal: countCtrl.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var pc = doc.querySelector('.product-count__text') || doc.querySelector('.product-count');
          var m = pc ? pc.textContent.match(/\d+/) : null;
          applyBtn.textContent = m ? m[0] + ' Produkte anzeigen' : 'Anwenden';
          applyBtn.classList.remove('is-loading');
        })
        .catch(function () { applyBtn.classList.remove('is-loading'); });
    }
    panelBody.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'checkbox') scheduleCount();
    });

    // ===== ÖFFNEN/SCHLIESSEN =====
    function openFilter() { filterOverlay.classList.add('is-open'); filterPanel.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeFilter() { filterOverlay.classList.remove('is-open'); filterPanel.classList.remove('is-open'); document.body.style.overflow = ''; }
    filterBtn.addEventListener('click', openFilter);
    filterOverlay.addEventListener('click', closeFilter);
    filterPanel.querySelector('#mac-filter-close').addEventListener('click', closeFilter);

    // ===== AKTIVE FILTER-CHIPS wie MAC =====
    function buildActiveChips() {
      if (document.getElementById('mac-active-filters')) return;
      var u = new URL(location.href);
      var params = [];
      u.searchParams.forEach(function (v, k) {
        if (k.indexOf('filter.') === 0) params.push({ k: k, v: v });
      });
      if (!params.length) return;

      var xSvg = '<svg width="10" height="10" viewBox="0 0 10 10"><line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" stroke-width="1.2"/><line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" stroke-width="1.2"/></svg>';
      var wrap = document.createElement('div');
      wrap.id = 'mac-active-filters';

      function removeParam(key, val) {
        var nu = new URL(location.href);
        var rest = nu.searchParams.getAll(key).filter(function (x) { return x !== val; });
        nu.searchParams.delete(key);
        rest.forEach(function (x) { nu.searchParams.append(key, x); });
        nu.searchParams.delete('page');
        location.href = nu.toString();
      }
      function addChip(label, onRemove) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'mac-chip';
        chip.innerHTML = xSvg + '<span>' + label + '</span>';
        chip.addEventListener('click', onRemove);
        wrap.appendChild(chip);
      }

      var gte = null, lte = null;
      params.forEach(function (p) {
        if (p.k === 'filter.v.price.gte') { gte = p.v; return; }
        if (p.k === 'filter.v.price.lte') { lte = p.v; return; }
        if (p.k.toLowerCase().indexOf('availability') !== -1) {
          addChip('Auf Lager', function () { removeParam(p.k, p.v); });
          return;
        }
        addChip(p.v, function () { removeParam(p.k, p.v); });
      });
      if (gte !== null || lte !== null) {
        var lbl = (gte || '0') + ' € – ' + (lte || (pr ? pr.cap : '')) + ' €';
        addChip(lbl, function () {
          var nu = new URL(location.href);
          nu.searchParams.delete('filter.v.price.gte');
          nu.searchParams.delete('filter.v.price.lte');
          nu.searchParams.delete('page');
          location.href = nu.toString();
        });
      }

      var reset = document.createElement('button');
      reset.type = 'button';
      reset.id = 'mac-chip-reset';
      reset.textContent = 'Zurücksetzen';
      reset.addEventListener('click', function () {
        var nu = new URL(location.href);
        Array.from(nu.searchParams.keys()).forEach(function (k) {
          if (k.indexOf('filter.') === 0) nu.searchParams.delete(k);
        });
        nu.searchParams.delete('page');
        location.href = nu.toString();
      });
      wrap.appendChild(reset);

      grid.parentElement.insertBefore(wrap, grid);
    }

    // ===== SALE-UNTERKACHELN wie MAC =====
    function buildSaleTiles() {
      if (document.getElementById('mac-sale-tiles')) return;
      if (location.pathname.indexOf('/collections/sale') === -1) return;
      if (location.pathname.indexOf('sale-damen') !== -1 || location.pathname.indexOf('sale-herren') !== -1) return;

      var tiles = [
        { label: 'SALE DAMEN', href: '/collections/sale-damen', img: 'https://cdn.shopify.com/s/files/1/0900/2077/4217/collections/EOSS_-_OHNE_TEXT.jpg?v=1761652182&width=400' },
        { label: 'SALE HERREN', href: '/collections/sale-herren', img: 'https://cdn.shopify.com/s/files/1/0900/2077/4217/collections/EOSS_-_OHNE_TEXT_0cf1270a-c785-473f-b063-5179813fec69.jpg?v=1761652141&width=400' }
      ];
      var wrap = document.createElement('div');
      wrap.id = 'mac-sale-tiles';
      tiles.forEach(function (t) {
        var a = document.createElement('a');
        a.className = 'mac-sale-tile';
        a.href = t.href;
        a.innerHTML = '<span class="mac-sale-tile__img" style="background-image:url(' + t.img + ')"></span><span class="mac-sale-tile__label">' + t.label + '</span>';
        wrap.appendChild(a);
      });
      if (window.matchMedia('(max-width: 989px)').matches) {
        bar.parentElement.insertBefore(wrap, bar);
      } else {
        grid.parentElement.insertBefore(wrap, grid.parentElement.querySelector('#mac-active-filters') || grid);
      }
    }
    buildSaleTiles();

    var heroWrap = document.querySelector('.collection-hero__text-wrapper');
    var fitBar = document.querySelector('.collection-sub-menu');
    if (fitBar) {
      bar.insertAdjacentElement('afterend', fitBar);
      var FIT_BAR_AUSSCHLUSS = ['accessoires', 'fit guide', 'fit-guide'];
      fitBar.querySelectorAll('a').forEach(function (a) {
        var t = a.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        var raus = FIT_BAR_AUSSCHLUSS.some(function (x) { return t === x || t.indexOf(x) !== -1; });
        if (raus) {
          var item = a.closest('li') || a;
          item.style.display = 'none';
        }
      });
    }
    if (heroWrap) heroWrap.style.display = 'none';

    buildActiveChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMacToolbar);
  } else {
    initMacToolbar();
  }
  document.addEventListener('shopify:section:load', initMacToolbar);
})();

// ===== SALE-MENÜ: Bild-Kacheln im Mobile-Drawer =====
(function () {
  function initSaleMenuTiles() {
    document.querySelectorAll('#link-sale .menu-drawer__inner-submenu, [id="link-sale"] .menu-drawer__inner-submenu').forEach(function (sub) {
      if (sub.querySelector('.mac-menu-sale-tiles')) return;
      var ul = sub.querySelector('ul');
      if (!ul) return;

      var tiles = [
        { label: 'SALE DAMEN', href: '/collections/sale-damen', img: 'https://cdn.shopify.com/s/files/1/0900/2077/4217/collections/EOSS_-_OHNE_TEXT.jpg?v=1761652182&width=400' },
        { label: 'SALE HERREN', href: '/collections/sale-herren', img: 'https://cdn.shopify.com/s/files/1/0900/2077/4217/collections/EOSS_-_OHNE_TEXT_0cf1270a-c785-473f-b063-5179813fec69.jpg?v=1761652141&width=400' }
      ];
      var wrap = document.createElement('div');
      wrap.className = 'mac-menu-sale-tiles';
      tiles.forEach(function (t) {
        var a = document.createElement('a');
        a.className = 'mac-sale-tile';
        a.href = t.href;
        a.innerHTML = '<span class="mac-sale-tile__img" style="background-image:url(' + t.img + ')"></span><span class="mac-sale-tile__label">' + t.label + '</span>';
        wrap.appendChild(a);
      });
      ul.parentElement.insertBefore(wrap, ul);

      ul.querySelectorAll('a').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.indexOf('sale-damen') !== -1 || href.indexOf('sale-herren') !== -1) {
          var li = a.closest('li');
          if (li) li.style.display = 'none';
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSaleMenuTiles);
  } else {
    initSaleMenuTiles();
  }
})();

// ===== HEADER-MENÜ: Hover öffnet, Klick navigiert (wie MAC) =====
(function () {
  var ZIEL_URLS = {
    'sale': '/collections/sale',
    'damen': '/collections/damen',
    'herren': '/collections/herren'
  };

  function initMacHoverMenu() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('.header__inline-menu header-menu > details').forEach(function (details) {
      if (details.getAttribute('data-mac-hover')) return;
      details.setAttribute('data-mac-hover', '1');
      var sum = details.querySelector('summary');
      if (!sum) return;

      var handle = (sum.id || '').replace('HeaderMenu-', '');
      var ziel = ZIEL_URLS[handle];

      if (ziel) {
        sum.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          location.href = ziel;
        }, true);
      } else {
        sum.addEventListener('click', function (e) { e.preventDefault(); }, true);
      }

      var host = details.closest('li') || details;
      var closeTimer = null;
      host.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) {
          if (d !== details) d.removeAttribute('open');
        });
        details.setAttribute('open', '');
      });
      host.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { details.removeAttribute('open'); }, 150);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMacHoverMenu);
  } else {
    initMacHoverMenu();
  }
})();

// ===== MOBILE-DRAWER: eigenes Schliessen-X wie MAC (v2, nutzt Dawns Close) =====
(function () {
  function initDrawerClose() {
    if (window.matchMedia('(min-width: 990px)').matches) return;
    var drawer = document.getElementById('menu-drawer');
    if (!drawer || drawer.querySelector('.mac-drawer-close')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mac-drawer-close';
    btn.setAttribute('aria-label', 'Menü schließen');
    btn.innerHTML = '<img class="close__icon" src="https://cdn.shopify.com/s/files/1/0900/2077/4217/files/svgviewer-png-output.png?v=1785756070">';
    btn.addEventListener('click', function () {
      var det = drawer.closest('details');
      var sum = det ? det.querySelector('summary') : null;
      if (sum && det && det.hasAttribute('open')) sum.click();
      setTimeout(function () {
        if (det) { det.classList.remove('menu-opening'); det.removeAttribute('open'); }
        document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden', 'mac-menu-open');
        document.documentElement.classList.remove('overflow-hidden');
        var hd = document.querySelector('header-drawer');
        if (hd) hd.classList.remove('menu-opening');
      }, 450);
    });
    drawer.insertBefore(btn, drawer.firstChild);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerClose);
  } else {
    initDrawerClose();
  }
})();

// ===== MOBILE-DRAWER: SALE als Direktlink (ohne Unterebene) =====
(function () {
  function initDrawerSaleLink() {
    if (window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('.menu-drawer summary.menu-drawer__menu-item').forEach(function (sum) {
      if (sum.textContent.replace(/\s+/g, ' ').trim().toUpperCase() !== 'SALE') return;
      if (sum.getAttribute('data-mac-sale-direct')) return;
      sum.setAttribute('data-mac-sale-direct', '1');
      sum.classList.add('mac-no-caret');
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        location.href = '/collections/sale';
      }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerSaleLink);
  } else {
    initDrawerSaleLink();
  }
})();

// ===== MOBILE-DRAWER: Announcement-Bar ausblenden wenn Menü offen =====
(function () {
  function initDrawerBarFix() {
    var det = document.getElementById('Details-menu-drawer-container');
    if (!det || det.getAttribute('data-mac-barfix')) return;
    det.setAttribute('data-mac-barfix', '1');
    var sync = function () {
      document.body.classList.toggle('mac-menu-open', det.hasAttribute('open'));
    };
    new MutationObserver(sync).observe(det, { attributes: true, attributeFilter: ['open'] });
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerBarFix);
  } else {
    initDrawerBarFix();
  }
})();

// ===== HEADER-ICONS wie MAC (v2): Lupe zeigt Original-Suche, MAC-Maße =====
(function () {
  function initMacHeaderIcons() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.mac-hicon--search')) return;

    function openSearch() {
      document.body.classList.add('mac-search-open');

      var inp = document.querySelector('.search__input');

      setTimeout(function(){
        if(inp){
          inp.focus();
        }

        // Load all products initially
        state.q = '';
        refetch();

      },150);

      var scope = window.matchMedia('(min-width: 990px)').matches ? icons : document.querySelector('.searchmobile-wrapper');
      var inp = scope ? scope.querySelector('input[type="search"]') : null;
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    }
    function closeSearch() {
      document.body.classList.remove('mac-search-open');
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
    document.addEventListener('click', function (e) {
      if (!document.body.classList.contains('mac-search-open')) return;
      if (e.target.closest('predictive-search') || e.target.closest('.mac-hicon--search') || e.target.closest('#mac-search-results') || e.target.closest('.header__icons') || e.target.closest('#mac-search-close')) return;
      closeSearch();
    });

    var searchBtn = document.createElement('button');
    searchBtn.type = 'button';
    searchBtn.className = 'mac-hicon mac-hicon--search';
    searchBtn.setAttribute('aria-label', 'Suche');
    searchBtn.innerHTML = '<svg aria-hidden="true" fill="none" focusable="false" width="22" class="header__nav-icon icon icon-search" viewBox="0 0 18 18"><path d="M12.113 12.277C14.609 9.781 14.609 5.742 12.113 3.246C9.62105 0.753999 5.57804 0.753999 3.08604 3.246C0.594041 5.742 0.594041 9.781 3.08604 12.277C5.57804 14.77 9.62105 14.77 12.113 12.277Z" stroke="currentColor" stroke-width="1.1"></path><path d="M12.398 12.559L16.523 16.684" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"></path></svg>';
    searchBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (document.body.classList.contains('mac-search-open')) closeSearch();
      else openSearch();
    });

    var heartBtn = document.createElement('button');
    heartBtn.type = 'button';
    heartBtn.className = 'mac-hicon mac-hicon--wishlist';
    heartBtn.setAttribute('aria-label', 'Wunschliste');
    heartBtn.innerHTML = '<svg aria-hidden="true" fill="none" focusable="false" width="12" class="header__nav-icon icon icon-heart" viewBox="0 0 20 16"><path d="M10.074 15.395C10.062 15.402 10.043 15.402 10.031 15.395L2.86701 9.055C2.85501 9.047 2.83601 9.031 2.82801 9.02C2.82801 9.02 -1.54701 5.039 2.84799 1.59C5.98399 -0.875001 10.031 3.066 10.031 3.066C10.043 3.078 10.062 3.078 10.07 3.066C10.07 3.066 14.004 -1.156 17.258 1.59C21.41 5.098 17.277 9.02 17.277 9.02C17.27 9.031 17.25 9.047 17.238 9.055L10.074 15.395Z" stroke="currentColor" stroke-miterlimit="10"></path></svg>';
    heartBtn.addEventListener('click', function () {
      var appBtn = document.querySelector('button.nm-wishlist-open-list-button:not(.mac-hicon)');
      if (appBtn) appBtn.click();
    });

    var accountLink = icons.querySelector('.header__icon--account');
    var cartLink = icons.querySelector('.header__icon--cart');
    icons.insertBefore(searchBtn, accountLink || cartLink);
    if (cartLink) icons.insertBefore(heartBtn, cartLink);
    else icons.appendChild(heartBtn);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMacHeaderIcons);
  } else {
    initMacHeaderIcons();
  }
})();
// ===== HEADER: MAC-Warenkorb-Icon + Logo-Sync =====
(function () {
var BAG_SVG = '<svg viewBox="0 0 17 16" fill="none"><path d="M5.19 4.25A3.59 3.59 0 0 1 12.37 4.25" stroke="currentColor" stroke-width="1.1"/><path d="M2.97 4.35C2.4 4.35 2.08 4.8 2.03 5.45L1.39 14.35C1.34 14.95 1.78 15.4 2.35 15.4H15.41C15.98 15.4 16.2 14.85 16.16 14.2L15.52 5.45C15.47 4.8 15.15 4.35 14.39 4.35H2.97Z" stroke="currentColor" stroke-width="1.1"/></svg>';

  function swapCartIcon() {
    var cart = document.querySelector('.header__icon--cart');
    if (!cart) return;
    var wrap = cart.querySelector('.svg-wrapper');
    if (wrap && wrap.getAttribute('data-mac-bag') !== '1') {
      wrap.innerHTML = BAG_SVG;
      wrap.setAttribute('data-mac-bag', '1');
    }
  }
  function initCartIcon() {
    swapCartIcon();
    var cart = document.querySelector('.header__icon--cart');
    if (cart) new MutationObserver(swapCartIcon).observe(cart, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartIcon);
  } else {
    initCartIcon();
  }
})();
/* ===== MAC-Suche: Schliessen per ESC und Backdrop-Klick ===== */
(function(){
  document.addEventListener('keydown',function(e){if(e.key==='Escape')document.body.classList.remove('mac-search-open');});
  document.addEventListener('click',function(e){
    if(!document.body.classList.contains('mac-search-open'))return;
    if(!e.target.closest('predictive-search.search-modal__form,#mac-search-close,.predictive-search--header,.header__icons,#mac-search-results'))document.body.classList.remove('mac-search-open');
  },true);
})();
/* MAC-Suche: Feld fokussieren beim Oeffnen */
(function(){
  new MutationObserver(function(){
    if(document.body.classList.contains('mac-search-open')){
      var i=document.querySelector('.search__input');
      if(i)setTimeout(function(){i.focus();},100);
    }
  }).observe(document.body,{attributes:true,attributeFilter:['class']});
})();
/* ===== MAC-Suche v7: Live-Ergebnisse, Sidebar, Sortierung, X + Linien fest im Overlay ===== */
(function(){
  var DEFAULT_COLLECTION='/collections/bestseller';
  var LINE='1px solid #ddd';
  var CMAP=[
    ['multi','linear-gradient(135deg,#e74c3c,#f1c40f,#2ecc71,#3498db,#9b59b6)'],
    ['hellblau','#a8c8e8'],['dunkelblau','#1a2f52'],['blau','#3468b0'],
    ['hellgrau','#c8c8c8'],['dunkelgrau','#555555'],['grau','#8a8a8a'],
    ['schwarz','#111111'],['weiss','#ffffff'],['weiß','#ffffff'],
    ['beige','#d9c7a8'],['braun','#7a5230'],
    ['dunkelgrün','#2d4a2d'],['grün','#5a8a4a'],['gruen','#5a8a4a'],['oliv','#6b7a42'],['khaki','#8a815c'],
    ['gelb','#f0c830'],['lila','#8a5aa8'],['violett','#7a4a9a'],
    ['orange','#e8862a'],['rosa','#f0b8c8'],['pink','#e0559a'],['rot','#c0392b'],
    ['türkis','#30b0a8'],['petrol','#2a6a72'],['denim','#4a6a92']
  ];
  function colorHex(t){t=String(t).toLowerCase();for(var i=0;i<CMAP.length;i++){if(t.indexOf(CMAP[i][0])!==-1)return CMAP[i][1];}return '#d0cdc8';}
  var caret='<svg class="mfb__caret" viewBox="0 0 10 6" width="12"><path fill="currentColor" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"/></svg>';
  var SORT_OPTS=[['','Relevanz'],['created-descending','Neuheiten'],['price-ascending','Preis aufsteigend'],['price-descending','Preis absteigend']];

  var state={q:'',sort:'',filters:{},gte:null,lte:null,priceCap:300};
  var openBlocks={farbe:true};
  var wrap=null,ctrl=null,timer=null;

  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');}
  function isChecked(n,v){return !!(state.filters[n]&&state.filters[n][v]);}
  function labelText(label,fallback){
    if(!label)return fallback;
    var c=label.cloneNode(true);
    c.querySelectorAll('.visually-hidden,svg,input').forEach(function(x){x.remove();});
    var t=c.textContent.replace(/\(\d+[^)]*\)/g,'').replace(/\s+/g,' ').trim();
    return t||fallback;
  }
  function closeAll(){document.body.classList.remove('mac-search-open');}

  function ensureWrap(){
    if(wrap)return wrap;
    wrap=document.createElement('div');
    wrap.id='mac-search-results';
    document.body.appendChild(wrap);

    wrap.addEventListener('change',function(e){
      var t=e.target;
      if(t.id==='mac-sr-sort'){state.sort=t.value;schedule(50);return;}
      if(!t.getAttribute||!t.getAttribute('data-name'))return;
      var n=t.getAttribute('data-name'),v=t.getAttribute('data-value');
      if(t.checked){(state.filters[n]=state.filters[n]||{})[v]=true;}
      else if(state.filters[n]){delete state.filters[n][v];if(!Object.keys(state.filters[n]).length)delete state.filters[n];}
      schedule(250);
    });
    wrap.addEventListener('click',function(e){
      if(e.target.closest('#mac-sr-x')){closeAll();return;}
      var h=e.target.closest('.mfb__head');
      if(h){var b=h.parentElement;b.classList.toggle('is-open');openBlocks[b.getAttribute('data-key')]=b.classList.contains('is-open');}
    });
    return wrap;
  }

  function renderShell(){
    var w=ensureWrap();
    if(w.querySelector('#mac-sr-layout'))return w;
    var sortHtml='<label class="mac-sr-sort">Sortieren nach: <select id="mac-sr-sort">';
    SORT_OPTS.forEach(function(o){sortHtml+='<option value="'+o[0]+'"'+(state.sort===o[0]?' selected':'')+'>'+o[1]+'</option>';});
    sortHtml+='</select></label>';
    w.innerHTML=
      '<div id="mac-sr-layout"><aside id="mac-sr-side"></aside><div id="mac-sr-main">'+
      '<div class="mac-sr-head" style="display:flex;align-items:center;gap:28px;"><span class="mac-sr-count" style="flex:1;"></span>'+sortHtml+
      '</div>'+
      '<ul id="mac-sr-grid"></ul><div class="mac-sr-empty" style="display:none"></div></div></div>';
    return w;
  }

  function parseFacets(doc){
    var d={geschlecht:[],farbe:[],fit:[],letters:[],numbers:[],laenge:[],price:null,avail:null};
    var seen={};
    doc.querySelectorAll('input[type="checkbox"][name*="availability"]').forEach(function(inp){
      if(inp.value==='1'&&!d.avail)d.avail={name:inp.name};
    });
    doc.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function(inp){
      var name=inp.name,ln=name.toLowerCase();
      if(ln.indexOf('availability')!==-1)return;
      var key=name+'||'+inp.value;
      if(seen[key])return;
      seen[key]=1;
      var label=inp.closest('label')||inp.parentElement;
      var opt={name:name,value:inp.value,disabled:inp.disabled,text:labelText(label,inp.value)};
      if(ln.indexOf('geschlecht')!==-1){d.geschlecht.push(opt);}
      else if(name==='filter.v.option.size'){
        if(/^(XS|S|M|L|XL|XXL|XXXL|2XL|3XL)$/i.test(inp.value))d.letters.push(opt);else d.numbers.push(opt);
      }else if(name==='filter.v.option.second size'){d.laenge.push(opt);}
      else if(ln.indexOf('colo')!==-1||ln.indexOf('farbe')!==-1){d.farbe.push(opt);}
      else if(ln.indexOf('fit')!==-1){d.fit.push(opt);}
    });
    var lte=doc.querySelector('input[name="filter.v.price.lte"]');
    if(lte){
      var raw=lte.getAttribute('max')||lte.getAttribute('placeholder')||'';
      var mx=Math.ceil(parseFloat(String(raw).replace(/[^\d.,]/g,'').replace(',','.')));
      if(!mx||isNaN(mx)||mx<1)mx=300;
      d.price={max:mx};
    }
    d.numbers.sort(function(a,b){return parseFloat(a.value)-parseFloat(b.value);});
    d.laenge.sort(function(a,b){return parseFloat(a.value)-parseFloat(b.value);});
    var so=['XS','S','M','L','XL','XXL','2XL','XXXL','3XL'];
    d.letters.sort(function(a,b){return so.indexOf(a.value.toUpperCase())-so.indexOf(b.value.toUpperCase());});
    return d;
  }

  function mfbOpen(key){return '<div class="mfb'+(openBlocks[key]?' is-open':'')+'" data-key="'+key+'" style="border-bottom:'+LINE+';box-shadow:none;margin:0;">';}
  function head(key,label){return '<button type="button" class="mfb__head" data-block="'+key+'"><span>'+label+'</span>'+caret+'</button>';}
  function swatchBlock(key,label,opts){
    if(!opts.length)return '';
    var h=mfbOpen(key)+head(key,label)+'<div class="mfb__body"><div class="mfb__swatches">';
    opts.forEach(function(o){
      var bg=colorHex(o.text||o.value);
      var style=bg.indexOf('gradient')!==-1?'background-image:'+bg:'background-color:'+bg;
      h+='<label class="mfb__swatch'+(o.disabled?' is-disabled':'')+'" title="'+esc(o.text)+'"><input type="checkbox" data-name="'+esc(o.name)+'" data-value="'+esc(o.value)+'"'+(isChecked(o.name,o.value)?' checked':'')+(o.disabled?' disabled':'')+'><span class="mfb__swatch-color" style="'+style+'"></span></label>';
    });
    return h+'</div></div></div>';
  }
  function listBlock(key,label,opts){
    if(!opts.length)return '';
    var h=mfbOpen(key)+head(key,label)+'<div class="mfb__body"><div class="mfb__list">';
    opts.forEach(function(o){
      h+='<label class="mfb__opt'+(o.disabled?' is-disabled':'')+'"><input type="checkbox" data-name="'+esc(o.name)+'" data-value="'+esc(o.value)+'"'+(isChecked(o.name,o.value)?' checked':'')+(o.disabled?' disabled':'')+'><span>'+esc(o.text)+'</span></label>';
    });
    return h+'</div></div></div>';
  }
  function gridBlock(key,label,opts){
    if(!opts.length)return '';
    var h=mfbOpen(key)+head(key,label)+'<div class="mfb__body"><div class="mfb__grid">';
    opts.forEach(function(o){
      h+='<label class="mfb__box'+(o.disabled?' is-disabled':'')+'"><input type="checkbox" data-name="'+esc(o.name)+'" data-value="'+esc(o.value)+'"'+(isChecked(o.name,o.value)?' checked':'')+(o.disabled?' disabled':'')+'><span>'+esc(o.value)+'</span></label>';
    });
    return h+'</div></div></div>';
  }
  function priceBlock(cap){
    var g=state.gte!=null?state.gte:0,l=state.lte!=null?state.lte:cap;
    return mfbOpen('preis')+head('preis','Preis')+
      '<div class="mfb__body"><div class="mfb__price">'+
      '<div class="mac-slider-track"><div class="mac-slider-range"></div>'+
      '<input type="range" class="mac-slider-min" min="0" max="'+cap+'" value="'+g+'" step="1">'+
      '<input type="range" class="mac-slider-max" min="0" max="'+cap+'" value="'+l+'" step="1"></div>'+
      '<div class="mfb__price-fields">'+
      '<span class="mfb__price-field"><span>€</span><input type="number" id="mac-sr-price-lo" min="0" max="'+cap+'" value="'+g+'" inputmode="numeric"></span>'+
      '<span class="mfb__price-bis">bis</span>'+
      '<span class="mfb__price-field"><span>€</span><input type="number" id="mac-sr-price-hi" min="0" max="'+cap+'" value="'+l+'" inputmode="numeric"></span>'+
      '</div></div></div>';
  }
  function availBlock(a){
    if(!a)return '';
    return '<div class="mfb'+(openBlocks['verf']?' is-open':'')+'" data-key="verf" style="border-bottom:none;box-shadow:none;margin:0;">'+head('verf','Verfügbarkeit')+      '<div class="mfb__body"><label class="mfb__toggle"><input type="checkbox" data-name="'+esc(a.name)+'" data-value="1"'+(isChecked(a.name,'1')?' checked':'')+'><span class="mfb__switch"></span><span class="mfb__toggle-label">Nur lagernde Artikel</span></label></div></div>';
  }
  function wirePrice(side,cap){
    var mn=side.querySelector('.mac-slider-min'),mx=side.querySelector('.mac-slider-max'),
        rg=side.querySelector('.mac-slider-range'),lo=side.querySelector('#mac-sr-price-lo'),hi=side.querySelector('#mac-sr-price-hi');
    if(!mn)return;
    function paintP(){
      var a=parseInt(mn.value,10),b=parseInt(mx.value,10);
      if(a>b){if(document.activeElement===mn){mx.value=a;b=a;}else{mn.value=b;a=b;}}
      rg.style.left=(a/cap*100)+'%';rg.style.right=(100-b/cap*100)+'%';
      lo.value=a;hi.value=b;
      state.gte=a>0?a:null;state.lte=b<cap?b:null;
    }
    function fromFields(){
      var a=parseInt(lo.value,10),b=parseInt(hi.value,10);
      if(isNaN(a))a=0;if(isNaN(b))b=cap;
      a=Math.max(0,Math.min(a,cap));b=Math.max(0,Math.min(b,cap));
      if(a>b){var t=a;a=b;b=t;}
      mn.value=a;mx.value=b;paintP();schedule(250);
    }
    mn.addEventListener('input',function(){paintP();schedule(400);});
    mx.addEventListener('input',function(){paintP();schedule(400);});
    lo.addEventListener('change',fromFields);hi.addEventListener('change',fromFields);
    paintP();
  }
  function renderSidebar(fd){
    var side=wrap.querySelector('#mac-sr-side');
    if(!side)return;
    var cap=fd.price?fd.price.max:state.priceCap;
    state.priceCap=cap;
    var h='';
    h+=listBlock('geschlecht','Geschlecht',fd.geschlecht);
    h+=swatchBlock('farbe','Farbe',fd.farbe);
    h+=gridBlock('groesse','Größe',fd.letters);
    h+=gridBlock('weite','Weite',fd.numbers);
    h+=gridBlock('laenge','Länge',fd.laenge);
    h+=listBlock('fit','Fit',fd.fit);
    if(fd.price)h+=priceBlock(cap);
    h+=availBlock(fd.avail);
    side.innerHTML=h;
    side.querySelectorAll(':scope > .mfb').forEach(function(m){m.style.setProperty('border-bottom','1px solid #ddd','important');});var vb=side.querySelector('.mfb[data-key="verf"]');if(vb)vb.style.setProperty('border-bottom','none','important');var ox=document.getElementById('mac-sr-x2');if(ox)ox.remove();var xb=document.createElement('button');xb.id='mac-sr-x2';xb.type='button';xb.setAttribute('aria-label','Suche schließen');xb.style.cssText='position:fixed;top:26px;right:36px;width:44px;height:44px;display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;padding:0;';xb.innerHTML='<img class="close__icon" src="https://cdn.shopify.com/s/files/1/0900/2077/4217/files/svgviewer-png-output.png?v=1785756070">';xb.onclick=function(){document.body.classList.remove('mac-search-open');};wrap.appendChild(xb);
    wirePrice(side,cap);
  }

  function buildUrl(){
    var p=new URLSearchParams();
    Object.keys(state.filters).forEach(function(n){Object.keys(state.filters[n]).forEach(function(v){p.append(n,v);});});
    if(state.gte!=null)p.append('filter.v.price.gte',state.gte);
    if(state.lte!=null)p.append('filter.v.price.lte',state.lte);
    if(state.sort)p.set('sort_by',state.sort);
    if(state.q){
      p.set('q',state.q);p.set('type','product');p.set('options[prefix]','last');
      return '/search?'+p.toString();
    }
    var qs=p.toString();
    return DEFAULT_COLLECTION+(qs?'?'+qs:'');
  }
  function schedule(ms){clearTimeout(timer);timer=setTimeout(refetch,ms||300);}
  function refetch(){
    if(ctrl)ctrl.abort();
    ctrl=new AbortController();
    var mode=!!state.q;
    fetch(buildUrl(),{signal:ctrl.signal})
      .then(function(r){return r.text();})
      .then(function(html){
        if(mode!==!!state.q)return;
        paint(new DOMParser().parseFromString(html,'text/html'));
      })
      .catch(function(){});
  }

  function paint(doc){
    var searchInput=document.querySelector('.search__input');
    var currentValue=searchInput ? searchInput.value : state.q;

    var w=renderShell();
    renderSidebar(parseFacets(doc));
    var src=doc.querySelector('#product-grid');
    var g=w.querySelector('#mac-sr-grid'),empty=w.querySelector('.mac-sr-empty'),cnt=w.querySelector('.mac-sr-count');
    g.innerHTML='';
    if(!src||!src.children.length){
      empty.style.display='block';
      empty.textContent=state.q?'Keine Ergebnisse für \u201E'+state.q+'\u201C':'Keine Produkte gefunden';
      cnt.innerHTML='<b>0</b> '+(state.q?'ERGEBNISSE':'PRODUKTE');
      return;
    }
    empty.style.display='none';
    var pc=doc.querySelector('.product-count__text')||doc.querySelector('.product-count');
    var m=pc?pc.textContent.match(/\d+/):null;
    cnt.innerHTML='<b>'+(m?m[0]:src.children.length)+'</b> '+(state.q?'ERGEBNISSE':'PRODUKTE');
    while(src.firstChild)g.appendChild(src.firstChild);

    setTimeout(function(){

        var inp=document.querySelector('.search__input');

        if(inp && inp.value!==currentValue){
            inp.value=currentValue;
            inp.focus();

            var len=inp.value.length;
            inp.setSelectionRange(len,len);
        }

    },0);


  }

  function onType(e){
    if(!document.body.classList.contains('mac-search-open'))return;
    var t=e.target;
    if(!t||!t.classList||!t.classList.contains('search__input'))return;
    var q=t.value.trim();
    var newQ=q.length>=2?q:'';
    if(newQ===state.q)return;
    state.q=newQ;
    schedule(300);
  }
  document.addEventListener('input',onType,true);
  // document.addEventListener('keyup',onType,true);

  new MutationObserver(function(){

    if(!document.body.classList.contains('mac-search-open')) return;

    var inp = document.querySelector('body.mac-search-open .search__input');

    if(!inp) return;

    // Don't rebuild while user is typing
    if(document.activeElement === inp) return;

    var q = inp.value.trim();

    state.q = q.length >= 2 ? q : '';

    renderShell();
    refetch();

  }).observe(document.body,{
    attributes:true,
    attributeFilter:['class']
  });
})();